<template lang="pug">
#app
  v-container(grid-list-md, fluid)
    v-layout(v-if="$root.user.permissao != 0", row, wrap)
      AccessLock
    v-layout(v-if="$root.user.permissao == 0", row, wrap)
      v-flex(lg12)
        form(@submit.prevent="salvar")
          v-card.elevation-1
            v-card-text
              v-layout(row, wrap)
                v-flex.md12.xs12
                  v-text-field(label="Nome", color="gray", required, v-validate="'required'", :error-messages="errors.collect('nome')", data-vv-name="nome", data-vv-as="Nome", type="text", v-model='tipo_identificador.nome')
              v-layout(row, wrap)
                v-flex.xs12
                  v-btn(type="submit", color="bt-primary", :loading='loading').white--text Salvar
</template>

<script>
import _ from 'lodash';
import AccessLock from '@/components/AccessLock';

export default {
  components: {
    AccessLock
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    loading: false,
    tipo_identificador: {},
  }),
  mounted () {
    const vm = this;
    if (vm.$route.params.id) {
      vm.getTipoIdentificador(vm.$route.params);
    }
  },
  methods: {
    async save (tipo_identificador) {
      const vm = this;
      try {
        const response = await vm.$axios.post('/tipo-identificador', tipo_identificador);
        tipo_identificador.id = response.data.id;
        vm.$router.push({ name: 'TipoIdentificadorLista', params: { id: response.data.id } });
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Tipo de identificador salvo com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar o tipo de identificador. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async update (tipo_identificador) {
      const vm = this;
      try {
        const response = await vm.$axios.put(`/tipo-identificador/${tipo_identificador.id}`, tipo_identificador);
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Tipo de identificador salvo com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao atualizar o tipo de identificador. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async salvar (scope) {
      const vm = this;
      try {
        vm.loading = true;  
        const result = await vm.$validator.validateAll();
        if (!result) throw 'Preencha todos os campos corretamente!';
        vm[vm.tipo_identificador.id ? 'update' : 'save'](vm.tipo_identificador);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },
    async getTipoIdentificador (params) {
      let vm = this;
      try {
        const response = await vm.$axios.get(`/tipo-identificador/${params.id}`);
        vm.tipo_identificador = response.data || {};
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
  },
};
</script>

<style scoped>

</style>

